import { DefaultDialogDom, IDialogController, IDialogDom } from "@aurelia/dialog";
import { ModelTypes } from "@zeus";
import { inject, resolve } from "aurelia";

@inject(IDialogDom)
export class MediaHistoryDrawer {
  $dialog: IDialogController;
  host: Element = resolve(Element);
  private medias: ModelTypes['userMedia'][]

  constructor(private dialogDom: DefaultDialogDom) {
    this.dialogDom.overlay.style.backgroundColor = "rgba(0, 0, 0, 0.5)";
    this.dialogDom.overlay.classList.add('backdrop-blur-glassed-button')
  }

  activate(model: {
    medias: ModelTypes['userMedia'][]
  }) {
    this.medias = model.medias
  }

  reuseParams(media: ModelTypes['userMedia']) {
    const aiParams = JSON.parse(media.aiParameters)

    this.$dialog.ok({
      colorPalette: aiParams.colorPalette,
      artisticStyle: aiParams.artisticStyle,
      perspective: aiParams.perspective,
      prompt: aiParams.prompt,
      aspectRatio: aiParams.aspectRatio,
    })
  }

  attaching() {
    const anim = this.host.animate(
      [
        { transform: 'translateX(100%)' },
        { transform: 'translateX(0)' }
      ],
      { duration: 300, easing: 'ease-out' }
    );
    return anim.finished;
  }

  detaching() {
    const anim = this.host.animate(
      [
        { transform: 'translateX(0)' },
        { transform: 'translateX(100%)' }
      ],
      { duration: 300, easing: 'ease-in' }
    );
    return anim.finished;
  }
}